import React, { Component } from "react";
import Slide from "react-reveal";

class Projects extends Component {
  getRandomColor() {
    let letters = "0123456789ABCDEF";
    let color = "#";
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  render() {
    if (!this.props.data) return null;

    const mission = this.props.data.mission;
    const remote = this.props.data.remote.map(function (remote) {
      return (
        <div key={remote.description}>
              <h3>{remote.description}</h3>
              <p className="info">
                  <p>{remote.details}</p> 
                  <p>{remote.detailsExtra}</p>
              </p>
        </div>
      );
    });

    const ai = this.props.data.ai.map(function (ai) {
      return (
        <div key={ai.description}>
              <h3>{ai.description}</h3>
              <p className="info">
                  <p>{ai.details}</p>
                  <p>{ai.detailsExtra}</p>
              </p>
        </div>
      );
    });

    return (
      <section id="projects">
        <Slide left duration={1000}>
            <div className="nine columns main-col">
                <div className="row mission">
                    <h1>{mission}</h1>
                </div>
            </div>
        </Slide>

        <Slide left duration={1000}>
          <div className="row ai">
            <div className="five columns header-col">
              <h1>
                <span>AI powered learning platform</span>
              </h1>
            </div>

            <div className="nine columns main-col">
                 <div className="row item">
                     <div className="twelve columns">{ai}</div>
                 </div>
            </div>
          </div>
        </Slide>

        <Slide left duration={1000}>
          <div className="row remote">
            <div className="five columns header-col">
              <h1>
                <span>Remote Learning Platform</span>
              </h1>
            </div>

            <div className="nine columns main-col">
              <div className="row item">
                <div className="twelve columns">{remote}</div>
              </div>
            </div>
          </div>
        </Slide>


      </section>
    );
  }
}

export default Projects;
